import { graphql } from 'app/generated/gql'

export const CREATE_COMM_LOG_WRITEBACK_RULE = graphql(`
  mutation CreateCommLogWritebackRule($input: CreateCommLogWritebackRuleInput!) {
    createCommLogWritebackRule(input: $input) {
      id
      orgId
      workspaceId
      locationId
      type
      channel
      version
      createdDate
      updatedDate
    }
  }
`)

export const UPDATE_COMM_LOG_WRITEBACK_RULE = graphql(`
  mutation UpdateCommLogWritebackRule($id: ID!, $input: UpdateCommLogWritebackRuleInput!) {
    updateCommLogWritebackRule(id: $id, input: $input) {
      id
      orgId
      workspaceId
      locationId
      type
      channel
      version
      createdDate
      updatedDate
    }
  }
`)

export const DELETE_COMM_LOG_WRITEBACK_RULE = graphql(`
  mutation DeleteCommLogWritebackRule($id: ID!) {
    deleteCommLogWritebackRule(id: $id)
  }
`)
